import React from 'react';
import { companyImage } from '@/utils/common/env.constants';
import { useRouter } from 'next/router';
import ProjectContent from './ProjectContent';

type Props = {
  galleryProjects: {
    title: string;
    img: string;
    desc: string;
  }[];
};

const Layout1 = ({ galleryProjects }: Props) => {
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  return (
    <div
      className={`${
        isDashboard ? 'px-1' : ''
      } w-full grid-cols-6 grid-rows-6 gap-5 max-h-[451px] hidden large:!grid`}
    >
      <div className="col-span-4 row-span-3 overflow-hidden rounded-xl shadow-light flex">
        <img
          src={`${companyImage}/project_gallery/${galleryProjects[0]?.img}`}
          alt={galleryProjects[0]?.title}
          className="h-full w-[40%] object-cover"
        />
        <ProjectContent projectContent={galleryProjects[0]} />
      </div>
      <div className="col-span-2 row-span-6 col-start-5 rounded-xl overflow-hidden flex flex-col max-h-[451px] shadow-light">
        <img
          src={`${companyImage}/project_gallery/${galleryProjects[1]?.img}`}
          alt={galleryProjects[1]?.title}
          className="max-h-52 w-full object-cover"
        />
        <ProjectContent projectContent={galleryProjects[1]} />
      </div>
      <div className="col-span-2 row-span-3 row-start-4 rounded-xl overflow-hidden flex shadow-light">
        <img
          src={`${companyImage}/project_gallery/${galleryProjects[2]?.img}`}
          alt={galleryProjects[2]?.title}
          className="h-full w-[40%] object-cover"
        />
        <ProjectContent projectContent={galleryProjects[2]} />
      </div>
      <div className="col-span-2 row-span-3 col-start-3 row-start-4 rounded-xl overflow-hidden flex shadow-light">
        <img
          src={`${companyImage}/project_gallery/${galleryProjects[3]?.img}`}
          alt={galleryProjects[3]?.title}
          className="h-full w-[40%] object-cover"
        />
        <ProjectContent projectContent={galleryProjects[3]} />
      </div>
    </div>
  );
};

export default Layout1;
